export const PRIORITIES = {
  1: { label: "EMERGENCY", short: "P1", cls: "bg-red-500/15 text-red-700 dark:text-red-300 border-red-500/50", dot: "bg-red-500", pulse: true },
  2: { label: "URGENT", short: "P2", cls: "bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/50", dot: "bg-amber-500", pulse: false },
  3: { label: "ROUTINE", short: "P3", cls: "bg-slate-500/10 text-slate-600 dark:text-slate-300 border-slate-500/40", dot: "bg-slate-400", pulse: false },
};
export const priorityInfo = (p) => PRIORITIES[Number(p) || 3] || PRIORITIES[3];

export const COLOR_CLS = {
  green: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-500/50",
  blue: "bg-blue-500/15 text-blue-700 dark:text-blue-300 border-blue-500/50",
  teal: "bg-teal-500/15 text-teal-700 dark:text-teal-300 border-teal-500/50",
  amber: "bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/50",
  slate: "bg-slate-500/15 text-slate-600 dark:text-slate-300 border-slate-500/50",
  red: "bg-red-500/15 text-red-700 dark:text-red-300 border-red-500/50",
};
export const colorCls = (c) => COLOR_CLS[c] || COLOR_CLS.slate;

export const CATEGORY = {
  available: { label: "AVAILABLE", cls: "text-emerald-600 dark:text-emerald-300", bar: "bg-emerald-500" },
  committed: { label: "COMMITTED", cls: "text-amber-600 dark:text-amber-300", bar: "bg-amber-500" },
  out_of_service: { label: "OUT OF SERVICE", cls: "text-slate-500 dark:text-slate-400", bar: "bg-slate-500" },
};

export const STATUS_CLS = {
  draft: "bg-slate-500/10 text-slate-600 dark:text-slate-300 border-slate-500/40",
  pending: "bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/50",
  active: "bg-blue-500/15 text-blue-700 dark:text-blue-300 border-blue-500/50",
  finished: "bg-slate-500/10 text-slate-500 dark:text-slate-400 border-slate-500/40",
};

let TZ = "America/Chicago";
export const setTimeZone = (tz) => { if (tz) TZ = tz; };
export const getTimeZone = () => TZ;

export function fmtTime(iso, withSeconds = true) {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("en-US", { hour: "2-digit", minute: "2-digit", second: withSeconds ? "2-digit" : undefined, hour12: false, timeZone: TZ }).format(new Date(iso));
  } catch { return "—"; }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("en-US", { month: "2-digit", day: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false, timeZone: TZ }).format(new Date(iso));
  } catch { return "—"; }
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("en-US", { month: "2-digit", day: "2-digit", year: "numeric", timeZone: TZ }).format(new Date(iso));
  } catch { return "—"; }
}

export function fmtTimeOrDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const sameDay = fmtDate(d.toISOString()) === fmtDate(new Date().toISOString());
  return sameDay ? fmtTime(iso, false) : `${fmtDate(iso).slice(0, 5)} ${fmtTime(iso, false)}`;
}

export function fmtAge(iso, nowMs = Date.now()) {
  if (!iso) return "";
  const s = Math.max(0, Math.floor((nowMs - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h${String(m % 60).padStart(2, "0")}m`;
  return `${Math.floor(h / 24)}d${h % 24}h`;
}

export function formatPhone(v) {
  const digits = (v || "").replace(/\D/g, "");
  if (digits.length === 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length === 11 && digits[0] === "1") return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  return v;
}
